import { createAction, props } from '@ngrx/store';
import { LookupModel } from '../../../models/common/lookup.model';
import { MailTemplateSendModel } from '../../../models/mail/mail-template-send.model';
import { MailTemplateModel } from '../../../models/mail/mail-template.model';
import { PreviewMailModel } from '../../../models/mail/preview-mail.model';
import { CommunicationLogDto, CommunicationLogPagingGetDto } from '../../models/communication-log.model';
import { SentMailLogModel } from '../../models/sent-mail-log.model';


export const SendMail = createAction('[Mail] Send Mail', props<{ model: FormData }>());
export const SendMailSuccess = createAction(
  '[Mail] Send Mail Success',
  props<{ response: boolean }>()
);
export const SendMailFailure = createAction(
  '[Mail] Send Mail Failure',
  props<{ err: any }>()
);


export const PreviewMail = createAction('[Mail] Preview Mail', props<{ model: PreviewMailModel }>());
export const PreviewMailSuccess = createAction(
  '[Mail] Preview Mail Success',
  props<{ response: PreviewMailModel }>()
);
export const PreviewMailFailure = createAction(
  '[Mail] Preview Mail Failure',
  props<{ err: any }>()
);

export const SaveMailTemplate = createAction('[Mail] Save Mail Template', props<{ model: MailTemplateModel }>());
export const SaveMailTemplateSuccess = createAction(
  '[Mail] Save Mail Template Success',
  props<{ response: LookupModel[] }>()
);
export const SaveMailTemplateFailure = createAction(
  '[Mail] Save Mail Template Failure',
  props<{ err: any }>()
);

export const GetMailMemberTemplates = createAction('[Mail] Mail Member Templates',
  props<{ memberIds: string }>());
export const GetMailMemberTemplatesSuccess = createAction(
  '[Mail]  Mail Member Templates Success',
  props<{ model: any }>()
);
export const GetMailMemberTemplatesFailure = createAction(
  '[Mail]  Mail Member Templates Failure',
  props<{ err: any }>()
);


export const GetMailTemplate = createAction('[Mail] Mail Template',
  props<{ id: number }>());
export const GetMailTemplateSuccess = createAction(
  '[Mail]  Mail Template Success',
  props<{ model: MailTemplateModel }>()
);
export const GetMailTemplateFailure = createAction(
  '[Mail]  Mail Template Failure',
  props<{ err: any }>()
);

export const GetCommunicationLogs = createAction('[Mail] Communication Logs', props<{ log: CommunicationLogPagingGetDto }>());
export const GetCommunicationLogsSuccess = createAction(
  '[Mail]  Communication Logs Success',
  props<{ model: CommunicationLogDto }>()
);
export const GetCommunicationLogsFailure = createAction(
  '[Mail]  Communication Logs Failure',
  props<{ err: any }>()
);


export const loadSentMailLogs = createAction(
  '[Mail] Load SentMailLogs',
  props<{ sentMailLogId: number }>()
);

export const loadSentMailLogsSuccess = createAction(
  '[Mail] Load SentMailLogs Success',
  props<{ sentMailLogs: SentMailLogModel }>()
);

export const loadSentMailLogsFailure = createAction(
  '[Mail] Load SentMailLogs Failure',
  props<{ err: any }>()
);

export const DeleteMailMemberTemplates = createAction('[Mail] Delete Mail Member Templates',
  props<{ index: number }>());


export const SaveReplyToEMailAddress = createAction('[Mail] Change Reply to Email Address for User',
  props<{ emailAddress: string }>());

export const SaveReplyToEMailAddresssSuccess = createAction(
    '[Mail] Change Reply to Email Address for User Success',
    props<{ response: boolean }>()
  );

export const SaveReplyToEMailAddressFailure = createAction(
    '[Mail] Change Reply to Email Address for User Failure',
    props<{ err: any }>()
);
